import { render, staticRenderFns } from "./LoginSecondaryVerification.vue?vue&type=template&id=5227a379&scoped=true"
import script from "./LoginSecondaryVerification.vue?vue&type=script&lang=js"
export * from "./LoginSecondaryVerification.vue?vue&type=script&lang=js"
import style0 from "./LoginSecondaryVerification.vue?vue&type=style&index=0&id=5227a379&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5227a379",
  null
  
)

export default component.exports